import React from 'react';
import RenderViewerSession from '@components/viewer-sessions/table/CustomCell/RenderViewerSession';
import { useViewerStore } from '@store/viewerModule/base';

interface IProps {
  column: {
    dataKey: string;
  };
  rowData: {
    [k: string]: any;
  };
}

const SessionRenderer = (cellProps: IProps) => {
  const {
    column: { dataKey },
    rowData,
  } = cellProps;
  const [{ viewerId, interval }] = useViewerStore();
  const { clientId, SessionId, SessionStartTime } = rowData;
  const summaries = [];

  return (
    <RenderViewerSession
      sessionId={SessionId}
      clientId={clientId}
      sessionStartTime={SessionStartTime}
      dataKey={dataKey}
      viewerId={viewerId}
      summaries={summaries}
      isLive={interval.isLive || false}
      isViewerModule
    />
  );
};

export default SessionRenderer;
